import Skeleton from '@mui/material/Skeleton';
import styles from './ProtocolSkeleton.module.css';

// Placeholder while the protocol (or the panel chunk) loads: Detected, an open section, two closed ones.
function ProtocolSkeleton() {
    return (
        <div className={styles['protocol-skeleton']} aria-busy="true" aria-label="Loading protocol">
            <Skeleton variant="rounded" height={52} />
            <Skeleton variant="rounded" height={120} />
            <Skeleton variant="rounded" height={44} />
            <Skeleton variant="rounded" height={44} />
        </div>
    );
}

export default ProtocolSkeleton;
